import React from 'react'

import { TableSearchFormStyled, TableSearchFormContentStyled, TableSearchFormInputStyled, TableSearchFormButtonStyled } from './styles'
import { IconSearch } from './../../../assets/svg/index'

interface Props {
  placeholder: string
  value: string
  onChange: void
  onSubmit: void
}

const TableSearchForm: React.FC<Props> = ({ placeholder, value, onChange, onSubmit }) => {
  return (
    <TableSearchFormStyled {...{ onSubmit }}>
      <TableSearchFormContentStyled>
        <TableSearchFormInputStyled {...{ placeholder, onChange, value }} />
        <TableSearchFormButtonStyled type="submit">
          <IconSearch />
        </TableSearchFormButtonStyled>
      </TableSearchFormContentStyled>
    </TableSearchFormStyled>
  )
}

export default TableSearchForm
